<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div class="d-flex justify-content-between w-100" slot="title">
      <h4>Edit Rider</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type_id"
            :options="types"
            v-model="form.type_id"
            label="Driver Type"
            placeholder="Please Select"
            helper="Please select whether this is the main driver or additional driver"
          ></selectlist>

          <inputbox
            v-model="form.name"
            name="name"
            label="Driver Name"
            helper="Please enter the name of the driver, as it is on their driving licence"
          ></inputbox>

          <date-of-birth
            v-model="form.date_of_birth"
            :value="form.date_of_birth"
            helper="Please enter the date of birth of the driver"
          ></date-of-birth>

          <spinner
            v-model="form.convictions"
            label="Convictions"
            helper="Please set the total number of convictions this driver has"
          ></spinner>

          <spinner
            v-model="form.points"
            label="Points"
            helper="Please set the total number of points this driver has"
          ></spinner>

          <input-block
            name="conviction_details"
            label="Conviction Details"
            v-model="form.conviction_details"
            helper="If this driver has had previous convictions, please enter the details about those here"
          ></input-block>

          <spinner
            v-model="form.accidents_in_three_years"
            label="Accidents Within The Last Three Years"
            helper="Please set the total number of accidents this drive has had within the past three years"
          ></spinner>

          <inputbox
            name="driving_licence"
            label="Driving Licence Number"
            v-model="form.licence_number"
            helper="Please enter the driving licence number for the proposed driver"
            :required="true"
            :show-error="form.errors.has('licence_number')"
            error-message="The driving licence number is required"
          ></inputbox>

          <div
            class="form-group has-helper"
            :class="{ 'has-error': form.errors.has('issue_date') }"
          >
            <div class="col-lg-4">
              <label for="issued_at" class="control-label">Issue Date: *</label>
              <p class="help-block">
                Please enter the date that the proposed drivers licence was
                issued
              </p>
            </div>
            <div class="col-lg-8">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.issue_date"
                v-on:selected="setIssuedAtDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
              <span
                class="text-danger"
                v-text="form.errors.get('issue_date')"
                v-if="form.errors.has('issue_date')"
              ></span>
            </div>
          </div>

          <div
            class="form-group has-helper"
            :class="{ 'has-error': form.errors.has('expiry_date') }"
          >
            <div class="col-lg-4">
              <label for="expires_at" class="control-label"
                >Expiry Date: *</label
              >
              <p class="help-block">
                Please enter the date that the proposed drivers licence expires
              </p>
            </div>
            <div class="col-lg-8">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.expiry_date"
                v-on:selected="setExpiresAtDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
              <span
                class="text-danger"
                v-text="form.errors.get('expiry_date')"
                v-if="form.errors.has('expiry_date')"
              ></span>
            </div>
          </div>

          <toggleswitch
            :labels="true"
            name="has_uk_licence"
            label="UK Licence?"
            v-model="form.has_uk_licence"
            helper="Does the proposed driver have a valid UK Licence?"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="has_new_licence"
            label="Licence Less Than 12 Months Old?"
            v-model="form.has_new_licence"
            helper="Is the proposed drivers licence less than 12 months old?"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          :indicator="indicator"
          v-on:clicked="deleteDriver"
          level="danger"
          >Delete</form-button
        >
      </div>
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="addDriver"
        >Update Driver</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    hire: {
      type: Object
    },

    types: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    },

    driver: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      indicator: false,
      form: new window.Form({
        type_id: this.driver.type_id,
        name: this.driver.name,
        date_of_birth: this.driver.date_of_birth
          ? window.DateManager.format(this.driver.date_of_birth)
          : null,
        convictions: this.driver.convictions,
        points: this.driver.points,
        conviction_details: this.driver.conviction_details,
        accidents_in_three_years: this.driver.accidents_in_three_years,
        licence_number: this.driver.licence_number,
        issue_date: this.driver.issue_date
          ? window.DateManager.format(this.driver.issue_date)
          : null,
        expiry_date: this.driver.expiry_date
          ? window.DateManager.format(this.driver.expiry_date)
          : null,
        city: this.driver.city,
        had_proposal_declined: this.driver.had_proposal_declined,
        has_uk_licence: this.driver.has_uk_licence,
        has_new_licence: this.driver.has_new_licence
      })
    };
  },

  methods: {
    deleteDriver() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              `/hires/${this.hire.identifier}/drivers/${this.driver.identifier}`
            )
              .then(response => {
                this.$emit('deleted', this.driver);
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the driver.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    closeModal() {
      this.$emit('close');
    },

    addDriver() {
      this.form
        .put(
          '/hires/' +
            this.hire.identifier +
            '/drivers/' +
            this.driver.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the driver.'
          );
        });
    },

    setIssuedAtDate(date) {
      this.form.issue_date = date;
    },

    setExpiresAtDate(date) {
      this.form.expiry_date = date;
    }
  }
};
</script>
